import { vappContainer, VApplication } from '../../../../../application';
import { logger as log } from '@common/logger';
import { ProfilePageService } from '@/pages/Profile/services';

const MODULE_NAME = 'profile.machines.states.setActive';

const getSrv = () => {
  return vappContainer.get<ProfilePageService>(ProfilePageService.displayName);
};

export const setActive = async (context: any, event: any) => {
  const currentState = 'SET_ACTIVE';
  const method = 'setActive';

  return new Promise(async (resolve, reject) => {
    try {
      log.log(MODULE_NAME, 'context: ', context, 'event: ', event);
      const srv = getSrv();
      const content = await srv.agent.setActive(event?.payload);
      if (content?.email) {
        return resolve({
          key: 'SET_ACTIVE_SUCCESS',
          value: {
            ...(content || {}),
          },
        });
      } else {
        const msg = 'User activation failed';
        log.error(MODULE_NAME, `error in ${method}, msg: ${msg}`);
        return reject({
          key: 'SET_ACTIVE_FAILED',
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(MODULE_NAME, `error in ${method}, msg: ${err?.message}`);
      let _msg = err?.message?.replace('GraphQL error:', '');
      return reject({
        key: 'SET_ACTIVE_FAILED',
        value: _msg,
      });
    }
  });
};
